const l = {
  name: "PlayCircleFill",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.5281 14.8817C10.203 14.7077 10 14.3688 10 14V10C10 9.63121 10.203 9.29235 10.5281 9.11833C10.8533 8.94431 11.2478 8.96338 11.5547 9.16795L14.5547 11.168C14.8329 11.3534 15 11.6656 15 12C15 12.3344 14.8329 12.6466 14.5547 12.8321L11.5547 14.8321C11.2478 15.0366 10.8533 15.0557 10.5281 14.8817Z" fill="currentColor"/>
    </g>
    `
};
export {
  l as PlayCircleFill
};
